import { render, staticRenderFns } from "./addConfig.vue?vue&type=template&id=b5c2aba6&scoped=true"
import script from "./addConfig.vue?vue&type=script&lang=js"
export * from "./addConfig.vue?vue&type=script&lang=js"
import style0 from "./addConfig.vue?vue&type=style&index=0&id=b5c2aba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c2aba6",
  null
  
)

export default component.exports